// extracted by mini-css-extract-plugin
export var border = "IntroBreed-module--border--5cb43";
export var bordersection = "IntroBreed-module--bordersection--16201";
export var breedherocontainer = "IntroBreed-module--breedherocontainer--b3055";
export var detail = "IntroBreed-module--detail--00b50";
export var detailscontainer = "IntroBreed-module--detailscontainer--7437b";
export var icon = "IntroBreed-module--icon--0f3a6";
export var imagecontainer = "IntroBreed-module--imagecontainer--6b354";
export var imagewrapper = "IntroBreed-module--imagewrapper--ed03d";
export var intro = "IntroBreed-module--intro--b976a";
export var keydetails = "IntroBreed-module--keydetails--53055";
export var optiontitle = "IntroBreed-module--optiontitle--89d9d";
export var optionvalue = "IntroBreed-module--optionvalue--5c515";
export var sizeguide = "IntroBreed-module--sizeguide--1113e";
export var sizeguidecontent = "IntroBreed-module--sizeguidecontent--f8d48";
export var text = "IntroBreed-module--text--1e920";
export var textcontainer = "IntroBreed-module--textcontainer--b5747";
export var title = "IntroBreed-module--title--40eae";
export var topsectionouter = "IntroBreed-module--topsectionouter--43a13";